import { defineMessages } from 'react-intl';

const messages = defineMessages({
    feedbackCtaText: {
        defaultMessage: 'Click to provide feedback',
        description: 'Call-to-action text describing what to do to navigate to specified feedback form',
        id: 'be.feedbackCtaText',
    },
    feedbackFormDescription: {
        defaultMessage: 'Beta Feedback Form',
        description: 'Accessible text used to describe the form used for feedback',
        id: 'be.feedbackFormDescription',
    },
});

export default messages;
